import { render } from "./ApplicationsTable.vue?vue&type=template&id=61c39f82&ts=true"
import script from "./ApplicationsTable.vue?vue&type=script&lang=ts"
export * from "./ApplicationsTable.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__